import React from 'react';
import classNames from 'clsx';
import type { IWutBadgeProps } from '../../../WutBadge.props';
import styles from './UDPBadge.scss';

import CommonBadge from '../../WutBadgeCommon';

const Badge: React.FC<IWutBadgeProps> = props => {
  const { stylableClassName } = props as any;

  const providedClassNames = {
    icon: styles.icon,
    root: classNames(styles.root, stylableClassName),
    outerWrapper: styles.outerWrapper,
    text: styles.text,
  };
  return <CommonBadge {...props} classNames={providedClassNames} />;
};

export default Badge;
